import { render, staticRenderFns } from "./thoroughfare.vue?vue&type=template&id=bfdc6aba&scoped=true&"
import script from "./thoroughfare.vue?vue&type=script&lang=js&"
export * from "./thoroughfare.vue?vue&type=script&lang=js&"
import style0 from "./thoroughfare.vue?vue&type=style&index=0&id=bfdc6aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdc6aba",
  null
  
)

export default component.exports